const ENC = new TextEncoder();

export class HMACUtility {
    static async importKey(secret) {
        return window.crypto.subtle.importKey(
            "raw",
            ENC.encode(secret),
            {name: "HMAC", hash: "SHA-256"},
            false,
            ["sign", "verify"]
        );
    }

    static async signMessage(messageString, secret) {
        const key = await HMACUtility.importKey(secret);
        const signatureBuffer = await window.crypto.subtle.sign(
            "HMAC",
            key,
            ENC.encode(messageString)
        );

        return Array.from(new Uint8Array(signatureBuffer))
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
    }

    static async verifyMessage(messageString, signatureHex, secret) {
        const key = await HMACUtility.importKey(secret);

        const signatureBytes = new Uint8Array(signatureHex.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));

        return window.crypto.subtle.verify(
            "HMAC",
            key,
            signatureBytes,
            ENC.encode(messageString)
        );
    }
}